// extracted by mini-css-extract-plugin
export var actionButton = "_65-0";
export var attachmentLine = "_65-1";
export var fileInput = "_65-2";
export var fileUploadWrapper = "_65-4";
export var footer = "_65-3";
export var modalContent = "_65-5";
export var paperclip = "_65-6";
export var quillEditor = "_65-7";